import React from 'react';
import { TableCell, Checkbox } from '@material-ui/core';

import Icon from 'src/components/Icon/Icon';

interface SingleCheckboxCellProps {
  checked: boolean,
  onChange: (e) => void, // eslint-disable-line no-unused-vars
  marketStatus: number
}

export default function SingleCheckboxCell({ checked, onChange, marketStatus }: SingleCheckboxCellProps) {
  return (
    <TableCell style={ { width: '60px' } }>
      <Checkbox
        name="isSelected"
        color="default"
        className="competitors-table__checkbox-container"
        checked={ checked }
        onChange={ onChange }
        icon={ marketStatus === 1 ? <Icon icon="checkbox" /> : <Icon icon="lockedSquare" className="competitors-table__checkbox--locked" /> }
        checkedIcon={ <Icon icon="checked" /> }
      />
    </TableCell>
  );
}
